import chainApi from '../blockchain/ChainApi';
import { useToast } from "vue-toastification";
const toast = useToast();

export async function exchangeLogin() {
  let result = {
    address: null,
    bindSuccess: false,
  };
  
  let connectRes = false;
  try {
    connectRes = await chainApi.connect();
  } catch (err) {
    connectRes = false;
    console.log('connect err:', err)
  }

  if(!connectRes) {
    return null;
  }

  let tempAddr = null;
  await chainApi.web3.eth.getAccounts()
  .then(res => {
    if(res.length) {
      tempAddr = res[0];
    }
  })
  .catch(err => {
    console.log(err);
  });

  let tempCid = await chainApi.web3.eth.getChainId();

  let incorrectChain = (process.env.VUE_APP_ENV == 'dev' ? (tempCid != 97) : (tempCid != 56));

  let switchRes = true;
  if(incorrectChain) {
    try{
      await chainApi.web3.currentProvider.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: process.env.VUE_APP_ENV == 'dev' ? chainApi.web3.utils.toHex(97) : chainApi.web3.utils.toHex(56) }]
      });
      switchRes = true;
    }
    catch(err) {
      toast.error('There was a problem switching the network. Try again in your wallet settings.', {timeout: 3000})
      switchRes = false;
    }
    if(switchRes) {
      await new Promise(resolve => setTimeout(resolve, 300));
    }
  }
  else {
    switchRes = true;
  }

  if(tempAddr && switchRes) {
    result.address = tempAddr;
    return result;
  }

  return null;
}
